import axios from 'axios';

import { responseEntityMapper, responseListMapper } from '@qwealth/qcore';
import { REACT_APP_QWEALTH_API_V3 } from '@qwealth/qdata';

import { CreateTagData, TagData } from 'data/models/TaskTags';

export const getTaskTagsApi = async (partnerId: number): Promise<TagData[]> =>
  axios.get(`${REACT_APP_QWEALTH_API_V3}/task/taskTag`, { params: { partnerId: partnerId } }).then(response => responseListMapper<TagData>(response));

export const postTaskTagsApi = async (tag: CreateTagData): Promise<TagData> =>
  axios.post(`${REACT_APP_QWEALTH_API_V3}/task/taskTag`, tag).then(response => responseEntityMapper<TagData>(response));

export const deleteTaskTagsApi = async (tagId: number) => axios.delete(`${REACT_APP_QWEALTH_API_V3}/task/taskTag/${tagId}`);
